<template>
  <div id="page-profile" class="d-flex">
    <!--MainBarMenu /-->
    <MainBarMenuV2 />
    <div class="layout-content container-fluid div1">
      <HeadingUser />
      <div class="banner">
           <img  align="center" width="100%" src="../../assets/images/login/banner.svg" alt="">
      <div class="banner-avatar">
        <div class="avatar ">
<object :data="serverPath + '/' + userData?.image" style="border: 4px solid #FFFFFF;
  border-radius: 50px; width:100px"  type="image/jpeg" @error="imageLoadError"
   onerror="this.style.border='0';">
      <img  style="border: 0;" src="../../assets/images/login/avatar.svg" >
    </object>
          </div>
          <div class="name ;"  style="color: #37474F; width: -webkit-fill-available; margin:8px;">
            <h3>{{user.name}}</h3>
            <label class="table-value" style="color: #78909C;" >{{user.position}}</label>
            </div>
            <div class="float-right w-100 " style="float: right !important; " > 
              <label class="cta-small incosistencia" v-b-modal.modal-1 >Reportar inconsistencia de datos <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" fill="white" fill-opacity="0.01"/>
<path d="M10.0001 18.3334C5.39758 18.3334 1.66675 14.6025 1.66675 10C1.66675 5.39752 5.39758 1.66669 10.0001 1.66669C14.6026 1.66669 18.3334 5.39752 18.3334 10C18.3334 14.6025 14.6026 18.3334 10.0001 18.3334ZM10.0001 16.6667C11.7682 16.6667 13.4639 15.9643 14.7141 14.7141C15.9644 13.4638 16.6667 11.7681 16.6667 10C16.6667 8.23191 15.9644 6.53622 14.7141 5.28598C13.4639 4.03573 11.7682 3.33335 10.0001 3.33335C8.23197 3.33335 6.53628 4.03573 5.28604 5.28598C4.03579 6.53622 3.33341 8.23191 3.33341 10C3.33341 11.7681 4.03579 13.4638 5.28604 14.7141C6.53628 15.9643 8.23197 16.6667 10.0001 16.6667ZM9.16675 13.3334C9.16675 12.8731 9.53984 12.5 10.0001 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3334C10.8334 13.7936 10.4603 14.1667 10.0001 14.1667C9.53984 14.1667 9.16675 13.7936 9.16675 13.3334ZM9.16675 6.66669C9.16675 6.20645 9.53984 5.83335 10.0001 5.83335C10.4603 5.83335 10.8334 6.20645 10.8334 6.66669V10C10.8334 10.4603 10.4603 10.8334 10.0001 10.8334C9.53984 10.8334 9.16675 10.4603 9.16675 10V6.66669Z" fill="#5D5FEF"/>
</svg></label>
 </div>
      </div>

<div class="row;" align="left">
        <form
          action="#"
          class="form-approval ">
           
            <div class="profile-card " deck>
              
      <div class="content-toggle">
        <div class="toggle-search">

          <button
                        type="button"
                        name="btn_profile"
                        class="btn_optionprofile"
                        @click="ActiveBtnProfile"
                        :class="{ bn_active: activeBtn === 'profile' }"

                      >
                      <span class="cta" > Perfil</span>
                      </button>
        </div>
      </div>

<div v-if="activeBtn === 'profile'">
            <div
              header="Tu perfil"
              header-tag="header"            
              footer-tag="footer"
              title="Verifica que tu información está correcta:">

              <label class="body_regular">⚠️ Por favor verifica que tu información este correcta</label>
              </div>
              <div>

                <div class="baseline_box">
                  <label for="nombre">Nombre</label>
                  <input id="nombre" v-model="user.name"  class="form-control" placeholder=" " readonly/>
                </div>
   
                <div class=" baseline_box">
                  <label for="cargo">Cargo</label>
                  <input id="cargo" v-model="user.position"  class="form-control" placeholder=" " readonly/>
                </div>
   
                <div class=" baseline_box">
                  <label for="rol">Rol</label>
                  <input id="rol" v-model="user.core_role_name"  class="form-control" placeholder=" " readonly/>
                </div>
   
               
                <div class=" baseline_box">
                  <label for="vinculo">Fecha de vinculación</label>
                  <input type="search" id="vinculo" style="padding: 15px 15px 15px 35px;" v-model="capitalize"  class="form-control" placeholder=" " readonly/>
                <svg class="input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.1666 2.50001H16.5C16.721 2.50001 16.9329 2.58781 17.0892 2.74409C17.2455 2.90037 17.3333 3.11233 17.3333 3.33334V16.6667C17.3333 16.8877 17.2455 17.0997 17.0892 17.2559C16.9329 17.4122 16.721 17.5 16.5 17.5H1.49996C1.27895 17.5 1.06698 17.4122 0.910704 17.2559C0.754423 17.0997 0.666626 16.8877 0.666626 16.6667V3.33334C0.666626 3.11233 0.754423 2.90037 0.910704 2.74409C1.06698 2.58781 1.27895 2.50001 1.49996 2.50001H4.83329V1.66668C4.83329 1.20644 5.20639 0.833344 5.66663 0.833344C6.12686 0.833344 6.49996 1.20644 6.49996 1.66668V2.50001H11.5V1.66668C11.5 1.20644 11.8731 0.833344 12.3333 0.833344C12.7935 0.833344 13.1666 1.20644 13.1666 1.66668V2.50001ZM11.5 4.16668H6.49996V5.00001C6.49996 5.46025 6.12686 5.83334 5.66663 5.83334C5.20639 5.83334 4.83329 5.46025 4.83329 5.00001V4.16668H2.33329V7.50001H15.6666V4.16668H13.1666V5.00001C13.1666 5.46025 12.7935 5.83334 12.3333 5.83334C11.8731 5.83334 11.5 5.46025 11.5 5.00001V4.16668ZM15.6666 9.16668H2.33329V15.8333H15.6666V9.16668Z" fill="#CFD8DC"/>
</svg>
                
                </div>
   
      <div class="row col-12 firma"  v-show="url !== null || signature !== null">  
        <div class="col-12 label-firma pl-0">
         <label class="label-regular mb-8 ml-0">Tú firma:</label>
        </div>
        
                      
                      
                      <div id="preview">
                        <img class="" v-if="url" align="center" width="100%" height="100"
                        :src="url" 
                        @error="imageLoadError"
                        onerror="style.display='none'"
                        />
                        <img class="" v-else align="center" width="100%" height="100"
                         :src="serverPath + signature + '?rand=' + rand"
                        @error="imageLoadError"
                        onerror="style.display='none'"
                        />

                      </div>
                      <div style="margin: 0px 8px;"><svg width="1" height="64" viewBox="0 0 1 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0.5" y1="64" x2="0.5" stroke="url(#paint0_linear_8012_713687)" stroke-opacity="0.8"/>
<defs>
<linearGradient id="paint0_linear_8012_713687" x1="1" y1="64" x2="1" y2="-3.8147e-06" gradientUnits="userSpaceOnUse">
<stop stop-color="#5D5FEF" stop-opacity="0"/>
<stop offset="0.489869" stop-color="#5D5FEF"/>
<stop offset="1" stop-color="#5D5FEF" stop-opacity="0"/>
</linearGradient>
</defs>
</svg></div>
                      <label class="custom-file-update" >
                        <input 
                            type="file" 
                            id="idsignature" 
                            name="signature" 
                            @change="uploadSignature"/>
                         
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.728 9.68599L14.314 8.27199L5 17.586V19H6.414L15.728 9.68599ZM17.142 8.27199L18.556 6.85799L17.142 5.44399L15.728 6.85799L17.142 8.27199ZM7.242 21H3V16.757L16.435 3.32199C16.6225 3.13452 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13452 17.849 3.32199L20.678 6.15099C20.8655 6.33852 20.9708 6.59283 20.9708 6.85799C20.9708 7.12316 20.8655 7.37746 20.678 7.56499L7.243 21H7.242Z" fill="white"/>
</svg>

                     
                      </label>
                 </div>
     
                     
                      <label class="custom-file-upload" v-show="url === null && this.signature === null" >
                          <input 
                            type="file" 
                            id="idsignature" 
                            name="signature" 
                            @change="uploadSignature"/>
                          <p class="cta-small" style="color:#5D5FEF; text-align: left;"
                           
                        >Añadir Firma
                          <svg width="20" height="20" style="margin-top:-3px;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.62092 13.6269C2.47206 13.831 2.46319 14.1917 2.59268 14.3885C2.74153 14.6164 3.01544 14.7225 3.29741 14.6656C3.49104 14.6253 3.60843 14.4873 3.72058 14.3454C3.92469 14.0876 4.1159 13.8209 4.31639 13.5595C4.40796 13.4385 4.48259 13.4131 4.61047 13.5168C5.31803 14.0912 6.12805 14.1779 6.98729 13.9892C7.93285 13.7818 8.70939 13.263 9.42582 12.6406C9.68279 12.4171 9.67956 12.4127 9.99058 12.5886C10.9587 13.1384 12.0326 12.8375 12.7696 12.0238C13.1367 11.6204 13.4174 11.1565 13.6639 10.6611C13.67 11.0335 13.7357 11.38 13.9168 11.6966C14.2767 12.3247 15.1129 12.4389 15.6434 11.9476C15.9395 11.6732 16.0996 11.3219 16.2582 10.9673C16.4308 10.5817 16.5728 10.1827 16.7939 9.82004C17.0149 9.45739 17.2965 9.23512 17.7491 9.22302C18.2017 9.21091 18.4623 8.74902 18.2735 8.33554C18.1239 8.05518 17.8899 7.94586 17.5757 7.96845C16.9254 8.01565 16.3957 8.29117 15.9766 8.78493C15.6244 9.20002 15.4211 9.6962 15.2077 10.1871C15.1295 10.3683 15.0673 10.5583 14.9382 10.7563C14.9173 10.5974 14.8979 10.4739 14.885 10.3529C14.8265 9.81924 14.8789 9.27989 14.8075 8.7462C14.7527 8.33958 14.5328 8.04953 14.1964 7.98459C13.8261 7.91318 13.5655 8.09471 13.3638 8.38556C13.2105 8.60662 13.1048 8.8531 12.9939 9.09635C12.7296 9.67401 12.4824 10.2601 12.1262 10.7906C11.9575 11.0423 11.7704 11.2795 11.5138 11.4486C11.2572 11.6176 10.9991 11.6607 10.7147 11.5329C10.5937 11.4784 10.5771 11.4304 10.6651 11.3175C11.1059 10.7602 11.4733 10.1486 11.7583 9.49773C12.1157 8.66754 12.3375 7.81234 12.1879 6.89945C12.0443 6.02085 11.346 5.46134 10.4803 5.55856C9.72071 5.6465 9.23663 6.1217 8.97442 6.79577C8.45 8.14393 8.46654 9.52758 8.87922 10.8947C8.99056 11.2638 8.92359 11.4482 8.64848 11.6696C8.07041 12.1359 7.4758 12.5607 6.74242 12.7475C6.2055 12.8838 5.70731 12.835 5.27244 12.4518C5.1954 12.3832 5.18087 12.3429 5.25268 12.2622C5.37596 12.1296 5.49011 11.9887 5.59436 11.8407C6.46448 10.5554 7.19262 9.19639 7.62707 7.69777C7.92397 6.67476 8.11115 5.63117 7.9147 4.56378C7.73801 3.59563 7.22206 2.89573 6.24181 2.59843C6.10425 2.55809 5.95499 2.57019 5.8251 2.5H5.26034C5.10826 2.54962 4.94448 2.53187 4.79321 2.59601C4.34661 2.78511 3.95643 3.08636 3.66047 3.47057C3.15582 4.11359 2.88958 4.8627 2.71491 5.6465C2.59307 6.21018 2.5262 6.78434 2.51522 7.36093C2.5003 7.92569 2.49263 8.48722 2.53539 9.04754C2.59737 9.83839 2.77571 10.6158 3.06465 11.3546C3.18043 11.6535 3.28128 11.9629 3.50839 12.2053C3.59512 12.2977 3.56406 12.3832 3.49346 12.4732C3.19737 12.8536 2.90329 13.2364 2.62092 13.6269ZM9.97323 7.59652C10.022 7.39517 10.1012 7.20243 10.208 7.0249C10.2473 6.95479 10.2992 6.89245 10.3609 6.84096C10.5941 6.66064 10.891 6.75302 10.966 7.03297C11.0652 7.39321 11.0204 7.75142 10.9257 8.10278C10.7389 8.79219 10.4101 9.41786 10.0382 10.0217C10.0325 10.0306 10.0148 10.0322 10.0003 10.0379C9.73079 9.22221 9.77395 8.40936 9.97323 7.59652ZM3.75486 7.52834C3.7952 6.68121 3.90775 5.849 4.21353 5.05229C4.34481 4.70067 4.53392 4.37344 4.77304 4.08414C5.21678 3.55327 6.35718 3.52422 6.64157 4.47947C6.82512 5.09747 6.79083 5.71265 6.68837 6.32945C6.42172 7.93416 5.72022 9.36259 4.8755 10.7317C4.74964 10.9334 4.62257 11.1383 4.43459 11.3154C3.89525 10.0988 3.69234 8.83777 3.75486 7.52834Z" fill="#5D5FEF"/>
<path d="M17.6003 15.8565C12.8101 15.8565 8.01971 15.8565 3.22924 15.8565C2.80728 15.8565 2.63544 15.9868 2.51765 16.3894C2.53862 16.7714 2.67658 16.9594 2.99648 17.0408H3.00414C3.00155 17.0522 3.00254 17.064 3.00697 17.0747H17.8237C17.8279 17.0641 17.8287 17.0524 17.8262 17.0413H17.8338C18.1408 16.963 18.2796 16.7863 18.3143 16.4301C18.2324 16.0182 18.0343 15.8565 17.6003 15.8565Z" fill="#5D5FEF"/>
</svg></p>
                      </label>             
               
              </div>
              </div>
           
            </div>
            <b-modal id="modal-1" class="mymodal" centered :hideFooter="false">
              <div v-if="!flagMsj">
              <h3 class=" mb-12 title-card" style="color: #263238;">Reporte de inconsistencias de datos</h3>
              <p class="table-value" style="text-align:center;color: #546E7A;margin-top:12px">Este mensaje le llegará al administrador de Virtual Partner</p>
              <textarea v-model="mensaje" class="body_regular" style="color: #263238;
              "></textarea><br><br><br><br>
              <div style="width:100%;display:flex;">
                
                <button v-if="!loadingOn" 
                  v-on:click="sendMsj"
                  type="button" 
                  class="button-primary enviar-mensaje"
                   style="border:none;">
                  <span class="cta"  style="width:100%">Enviar reporte</span>
                
                
                </button>
                
              <button v-else-if="loadingOn" class="button-primary enviar-mensaje"  style="border:none;" role="status" >
                <img class="spinner-logo"  src="../../assets/images/login/master_isotipo_VP.svg" style="margin:auto;width:20px; height:20px;"  alt="logo" />
                <span class="sr-only">Loading...</span>
              </button>  
              <button 
                type="button"  
                class="button-secundary btn_return" @click="$bvModal.hide('modal-1')">
                <span class="cta" style="width:100%">Volver</span>
              </button>
              </div>
              </div>
              <div v-else>
                <div style="position: realtive;
                display:flex;
                width:100%;
                padding-top:20px;
                padding-bottom:20px;
">
                  <svg width="60" height="60" style="margin: auto;" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="60" height="60" fill="white" fill-opacity="0.01"/>
<path d="M30 55C16.1925 55 5 43.8075 5 30C5 16.1925 16.1925 5 30 5C43.8075 5 55 16.1925 55 30C55 43.8075 43.8075 55 30 55ZM30 50C35.3043 50 40.3914 47.8929 44.1421 44.1421C47.8929 40.3914 50 35.3043 50 30C50 24.6957 47.8929 19.6086 44.1421 15.8579C40.3914 12.1071 35.3043 10 30 10C24.6957 10 19.6086 12.1071 15.8579 15.8579C12.1071 19.6086 10 24.6957 10 30C10 35.3043 12.1071 40.3914 15.8579 44.1421C19.6086 47.8929 24.6957 50 30 50ZM28.2146 39.2929C27.8241 39.6834 27.1909 39.6834 26.8004 39.2929L17.6071 30.0996C17.2166 29.7091 17.2166 29.0759 17.6071 28.6854L19.7279 26.5646C20.1184 26.1741 20.7516 26.1741 21.1421 26.5646L27.5075 32.93L40.9406 19.4945C41.3311 19.104 41.9641 19.1039 42.3547 19.4942L44.4774 21.6154C44.8682 22.0059 44.8683 22.6392 44.4776 23.0299L28.2146 39.2929Z" fill="#0C9E42"/>
</svg>
                </div>
                 <h3 class="mt-20 mb-12 title-card" style="color: #263238;">¡Tu reporte de inconsistencia de datos se ha enviado exitosamente!</h3>
            <button 
                type="button" 
                class="button-primary btn_understand" @click="$bvModal.hide('modal-1')">
                <span class="cta">Entendido</span>
              </button>
              </div>
            </b-modal>
        </form>      
      </div>
      </div>
      
      
      <!-- .row -->      
      <div class="mb-menu"></div>
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import PwdChange from "@/views/login/pwdChange.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "ProfileAdmin",  
  components: {
    HeadingUser,
    MainBarMenuV2,
    PwdChange,
  },
  data() {
    return {
      activeBtn: "profile",
      serverPath: serverConfig.permisosURL,
      flagMsj: false,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      mensaje: '',
      signature: "",
      profileUser: null,
      oneDay: '',
      fechaIni: '',
      fechaFin: '',
      estado: [],
      rand: 1,
      url: null,
    };
  },
  
  beforeMount() {   
    this.activeBtn = "profile"; 
    this.actGetProfile(this.user.id).then(() =>{
            this.profileUser = this.profile.data;
            this.signature = this.profileUser?.signature;
            }).catch((response) => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "No se pudo conectar al servicio: "+response;
            });

  },
  computed: {
    ...mapState("modCore", ["user","userData","profile","loadingOn"]),
    capitalize: function() {
        return this.user.created_at.substring(0,10);
    },
  },
  methods: {
    
    ...mapActions("modCore", [      
      "actGetProfile",
      "actSaveSignature",
      "actSendMsjAdmin",
      ]),

    uploadSignature(e){      
      var formData = new FormData();
      var validator = "#idsignature";
      var file = document.querySelector( validator );      
      formData.append("signature", file.files[0]);      
      this.actSaveSignature(formData);

      const image = e.target.files[0];
      this.url = URL.createObjectURL(image);
    },

    sendMsj(){
      this.flagMsj = false;      
      this.actSendMsjAdmin({ 'message':this.mensaje}).then(() =>{
        this.flagMsj = true;
      });
    },

    imageLoadError(event) {
      event.target.src = "";
    },
    ActiveBtnProfile() {
      this.activeBtn = "profile";
    },
    ActiveBtnPassword() {
      this.activeBtn = "password";
    }
  },
};
</script>

<style lang="scss">
#page-profile {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-profile {
  .content-toggle{
/* Auto layout */
display: flex;
flex-direction: row;
align-items: flex-start;
padding: 0px;

border:none;
box-sizing: border-box;


position: relative;
width: 376px;
height: 56px;
margin-bottom: 24px;
.toggle-search{
        /* Auto layout */

display: flex;
flex-direction: row;
align-items: flex-start;
padding: 8px;

position: static;
left: 0%;
right: 0%;
top: 0%;
bottom: 0%;

/* CTA/00 */

background: #ECECFF;
/* CTA/01 */

border: 1px solid #C9CAFF;
box-sizing: border-box;
border-radius: 48px;

/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
margin: 0px 0px;
    }
    
.btn_optionprofile {

display: flex;
flex-direction: row;
justify-content: center;
align-items: center;


position: static;
left: 0%;
right: 0%;
top: 0%;
bottom: 0%;

/* content/00 overlay */

color: #5D5FEF;
border-radius: 100px;
border:none;
background: none;

/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
margin: 0px 1px;
padding: 5px 25px;

}

.btn_optionprofile:hover{
  background: #C9CAFF;
  color: #5D5FEF;
}
.btn_optionprofile:active,
.btn_optionprofile:visited,
.btn_optionprofile:link,
.btn_optionprofile:focus,
.bn_active{
    /* _cta base master */

/* Auto layout */

display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 5px 25px;

position: static;
left: 0%;
right: 0%;
top: 0%;
bottom: 0%;

/* content/00 overlay */
color:#263238;
background: rgba(255, 255, 255, 0.88);
border-radius: 100px;
border:none;

/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
margin: 0px 1px;
  
}
    }
     

  .cont-search {

 
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }
  .button1 {
    background: #E9ECEE;
    color: #1C3A4E;
    //border-radius: 50px;
    height: 24px;
    font-size: 12px;
    text-align: right !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }  
  
  .div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    //margin-right: 40px;
    margin-right: 0px;
    //margin-left: 40px;    
    margin-left: 0px;    
  }
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #E9ECEE;
    border-color: #E9ECEE;  
    background: #E9ECEE;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 90%;
    align-self: center;
  }
  .td1 {
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .td2 {
    background: #E9ECEE;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td3 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 80px;
    //width: 50px;
    text-align: center;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    color: #454545;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;    
    text-align: right !important;
    padding: 1%;
    margin: 1%;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;    
    
  }
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    color: #454545;
    font-size: 14px;    
    line-height: 20px;    
    text-align: left !important;
    padding: 1%;
    margin: 1%;
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%; 
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
.custom-file-upload {

 justify-content: center;
cursor: pointer;
         
border: 1px dashed #5D5FEF;
box-sizing: border-box;
border-radius: 4px;
padding: 4px 12px;
width: 141px;
height: 28px;
margin: 24px 0;



  }
  .custom-file-update {
 
padding: 8px;
width: 40px;
height: 40px;

/* CTA/03 */

background: rgb(93, 95, 239);
border-radius: 200px;

  }
  .custom-file-upload:hover {
    background:  #ECECFF;;
  }
  .custom-file-upload:active {
    background: #C9CAFF;
  }
  .custom-file-update:hover {
    background:  #7A7CFF;
  }
  .custom-file-update:active {
    background: #1719DA;
  }

  input[type="file"] {
    display: none;
  }
.firma{
   display: flex;
  /* align-items por defecto tiene el valor `stretch` */
  align-items: center;
}
  #preview {
    display: flex;
    justify-content: left;
    align-items: left;
    background: #ECECFF;
border-radius: 8px;
width:194px;
height:64px;

  }

  #preview img {
    position: realtive;
height: 56px;
margin-left: 8px;
margin-right: 8px;
margin-top: 4px;
  }
.profile-card{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 24px;

position: realtive;
width: 476px;
height: 464px;
/*left: 112px;
top: 290px;*/

margin: 24px 40px;


/* content/00 */

background: #FFFFFF;
/* CTA/01 */

border: 1px solid #C9CAFF;
box-sizing: border-box;
border-radius: 8px;
}
}

.baseline_box{
position: relative;
margin-top: 8px;
margin-bottom: 8px;
/* content/00 */
background: #FFFFFF;
/* content/01 */
border: 1px solid #ECEFF1;
box-sizing: border-box;
border-radius: 8px;
label{
 /* label */
 position:absolute;
  left:4px;
  top:-8px;
  line-height:1;
  font-weight:bold;
  padding:4 6px;
  display:none;
 
/* label regular */
font-family: Ubuntu;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;
/* identical to box height, or 133% */
display: flex;
align-items: center;
/* content/02 */
color: #CFD8DC;
background: #ffffff;
/* Inside auto layout */
flex: none;
order: 0;
flex-grow: 0;
margin: 0px 4px;
padding: 0px 4px;
}
input{
  
position: static;
width: 412px;
height: 28px;
left: calc(50% - 412px/2);
top: calc(50% - 28px/2);
background: #ffffff;
/* body regular */
font-family: Ubuntu;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 28px;
/* content/03 */
color: #B0BEC5;

margin: 8px;
border:0;
 &:focus, &:active {
            outline: 0;
            border:0;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
           box-shadow: none;
          }
	
}
}
.incosistencia{
float:right !important;
/* CTA/03 */
color: #5D5FEF;
margin-top:16px;
margin-right:45px;
/* Inside auto layout */

}
.banner{
//position: absolute;
position: relative;
//left: 72px;
left: 0px;
right: 0px;
//top: 56px;
top: 0px;
bottom: 658px;
margin-bottom: 100px;
background-size: cover;

.avatar{
  display: flex !important;
  margin-left:40px;
  margin-top: -30px;
  margin-right: 8px;
  
  width: 100px;
  height: 100px;
}
}
.banner-avatar{
 display: flex !important;
 width:100%;
}
.input-icon {
	color: #191919;
	position: absolute;
	width: 20px;
	height: 20px;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
}

.enviar-mensaje{
position: relative;
margin: 0px 0px;
width: 156px;
}
.btn_return{
position: relative;
margin: 0px 0px;
width: 89px;
}

.btn_understand{
position: absolute;
bottom: 16px;
left: 25%;
margin: auto;
width: 189px;

}
.modal-content{
  height: 300px !important;
}
</style>
